import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["field", "input"]

  toggle(event) {
    event.preventDefault()

    this.enableInputs()
    this.showFields()

    event.currentTarget.style.display = "none"
  }

  enableInputs() {
    this.inputTargets.forEach(input => {
      input.disabled = false
      input.dispatchEvent(new Event("chosen:updated"))
    })
  }

  showFields() {
    this.fieldTargets.forEach(field => {
      field.hidden = false
    })
  }
}
